// Screen resolution media queries
export const mobileLayoutMediaQuery = '(max-width: 1023px)';
export const desktopLayoutMediaQuery = '(min-width: 1024px)';
export const tabletLayoutMediaQuery = '(min-width: 768px)';
export const smallMobileLayoutMediaQuery = '(max-width: 368px)';

export const modulorMobileMediaQuery = '(max-width: 599px)';
// Other media queries
export const pwaLayoutMediaQuery = '(display-mode: standalone)';
export const betbookMobileMediaQuery = '(max-width: 1280px)';
export const betbookDesktopLayoutMediaQuery = '(min-width: 1280px)';
